import { Directive, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsidedDirective {

  constructor(private elementRef: ElementRef) { }

  @Output() clickedOutside: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
          this.clickedOutside.emit(true);
      }
  }
}
